<template>
    <div>
        <div class="row justify-content-between">
            <div class="col-12 d-flex align-self-center">
                <h3 class="text-muted">{{title}}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-lg" v-if="search.hasOwnProperty('shop_code')">
                <InputShopCode
                    :filter="search" 
                    :addClass="'form-control'"
                    :config="{ key : 'shop_code' , error : 'error'}"
                />
            </div>
            <div class="col-lg" v-if="search.hasOwnProperty('card_id')">
                <b-input-group>
                    <b-form-input  v-model="search.card_id" placeholder="ค้นหาเลขบัตรประชาชน"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg" v-if="search.hasOwnProperty('name')">
                <b-input-group>
                    <b-form-input v-model="search.name" placeholder="ค้นหาชื่อร้านค้า"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg" v-if="search.hasOwnProperty('owner_name')">
                <b-input-group>
                    <b-form-input  v-model="search.owner_name" placeholder="ค้นหาชื่อเจ้าของร้าน"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg" v-if="search.hasOwnProperty('api_key')">
                <b-input-group>
                    <b-form-input v-model="search.api_key" placeholder="ค้นหา API KEY"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg" v-if="search.hasOwnProperty('email')">
                <b-input-group>
                    <b-form-input  v-model="search.email" placeholder="ค้นหาอีเมล์"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg" v-if="search.hasOwnProperty('status_register')">
                <select class="form-control" @click.stop.prevent 
                    v-model="search.status_register">
                    <option :value="''">ดูทั้งหมด</option>
                    <option :value="status.key" v-for="status in statusDefault" :key="status.key">{{status.title}}</option>
                </select>
            </div>
            <div class="col-lg-1">
                <div class="row">
                    <button class="btn btn-info btn-sm-res" @click="$emit('getCommission')" :disabled="search.error" >
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InputShopCode from '@/components/custom/BaseInput/ShopCode'
export default {
    props:{
        search:Object,
        title:String
    },
    components:{
        InputShopCode
    },
    data(){
        return{
            statusDefault:[
                { key: '-1' , title: 'รอยืนยัน'},
                { key: '0' , title: 'รอดำเนินการ'},        
                { key: '1' , title: 'รอส่งเอกสารออฟไลน์'},
                { key: '2' , title: 'ยืนยันตัวตนแล้ว'},
                { key: '-2' , title: 'ยืนยันตัวตนไม่ผ่าน'},
                { key: '-3' , title: `ยืนยันตัวตนไม่ผ่าน ${this.$THEME.webTitle}`},
                { key: null , title: 'ยังไม่ยืนยันตัวตน' }
            ]
        }
    }
}
</script>
